// react components

// react-router-dom components

// mui components
// import FormControlLabel from '@mui/material/FormControlLabel';

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import GraphLayoutHeader from "./GraphLayoutHeader";

//routes

//assets

function GraphLayout({
    children = <></>,
    title = "",
    backendVariable = "",
    minHeight = 500,
    card = false,
    fetchSwitchState = () => {},
    sampleSize = 0,
    // fetchModalState = () => {},
}) {
    const graph = (
        <>
            <GraphLayoutHeader
                title={title}
                backendVariable={backendVariable}
                fetchSwitchState={fetchSwitchState}
                sampleSize={sampleSize}
                // fetchModalState={fetchModalState}
            />
            <div
                style={{
                    marginBottom: "10px",
                    marginTop: "20px",
                    height: "350px",
                    minHeight: "350px",
                }}
            >
                {children}
            </div>
        </>
    );

    const box = (
        <>
            <div
                style={{
                    marginBottom: "10px",
                    marginTop: "0px",
                }}
            >
                {children}
            </div>
        </>
    );

    return (
        <div
            style={{
                minHeight: `${minHeight}px`,
                padding: "0px 16px",
            }}
        >
            {!card && <>{graph}</>}
            {card && <>{box}</>}
        </div>
    );
}

// Typechecking props for the GraphLayout
GraphLayout.propTypes = {
    children: PropTypes.object,
    title: PropTypes.string,
    backendVariable: PropTypes.string,
    minHeight: PropTypes.number,
    card: PropTypes.bool,
    fetchSwitchState: PropTypes.func,
    sampleSize: PropTypes.number,
    // fetchModalState: PropTypes.func,
};

export default GraphLayout;
